import api from "../api";

// Share task (supports multiple users)
export const shareTask = async (taskId, sharedWithIds) => {
  // Ensure sharedWithIds is an array
  const ids = Array.isArray(sharedWithIds) ? sharedWithIds : [sharedWithIds];
  return await api.getApi().post(`/tasks/${taskId}/share`, { sharedWithIds: ids });
};

// Get tasks shared with me
export const getSharedTasks = async (status) => {
  return await api.getApi().get("/tasks/shared-with-me", {
    params: status ? { status } : {},
  });
};

// Accept/Decline shared task
export const acceptSharedTask = async (sharedId) => {
  return await api.getApi().post(`/tasks/shared/${sharedId}/accept`);
};

export const declineSharedTask = async (sharedId) => {
  return await api.getApi().post(`/tasks/shared/${sharedId}/decline`);
};

// Get users task is shared with
export const getSharedUsers = async (taskId) => {
  return await api.getApi().get(`/tasks/${taskId}/shared-users`);
};
